import React, { useState, useEffect, useRef} from "react";
import {Info, User, UserRoundCog, Newspaper, Atom} from "lucide-react"
import {SearchCode, FileStack, FileSearch2, FlaskConical} from "lucide-react";
import { SiMoleculer } from "react-icons/si";
import { FaHourglassStart } from "react-icons/fa6";
import axios from "axios";
import logo1 from './logo1.svg';
import full_logo from './full_logo.svg';
import dprl_logo from './dprl_logo.png';
import nsf_logo from './NSF_logo.png';
import rit_logo from './RIT_logo.jpg';
import './App.css';

function App() {
  const [txtin, setTxtIn] = useState("");
  const [smiin, setSMIIn] = useState("");
  const [pData, setPData] = useState([]);
  const [dLinks, setDLinks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [forceState, setForceState] = useState(0);
  const [pImgF, setPImgF] = useState({});
  const [pLImgF, setPLImgF] = useState({});
  const [dImgsF, setDImgsF] = useState({});
  const [dLImgsF, setDLmgsF] = useState({});
  const [geneF, setGeneF] = useState({});
  const [selectedPassage, setSelectedPassage] = useState(null);
  const [selPasMeta, setSelPasMeta] = useState([]);
  const [exists, setExists] = useState(false);
  const [isModalOpenP, setIsModalOpenP] = useState(false);
  const [selectedModalImg, setSelectedModalImg] = useState(null);
  const [isAboutOpen, setIsAboutOpen] = useState(false);
  const [isHowToOpen, setIsHowToOpen] = useState(false);
  
  const handleTxtIn = (event) => {
    setTxtIn(event.target.value);
  }

  const handleSMIIn = (event) => {
    setSMIIn(event.target.value);
  }

  const handlePassageClick = (indexP) => {
    setSelectedPassage(indexP);
    
  }

  useEffect (() => {
    if (pData.length > 0) {
    console.log('Selected Passage: ', selectedPassage);
    setSelPasMeta(pData[selectedPassage]);
    const docno = pData[selectedPassage].docno;
    const doesExist = dLinks.some(item => item["docno"] === docno);
    setExists(doesExist);
    console.log('D Matches Exist: ', doesExist)
    }
  }, [selectedPassage]);

  // Set temp counter to loop through selected passage diagram matches
  let tempCounter = -1;

  useEffect (() => {
    console.log('Restting tempCount to -1')
    tempCounter = -1;
  }, [selPasMeta]);


  useEffect (() => {
    console.log('Passage Modal Opened or closed')
  }, [isModalOpenP]);

  useEffect (() => {
    console.log('About Modal Opened or Closed')
  }, [isAboutOpen]);

  useEffect (() => {
    console.log('How-To Modal Opened or Closed')
  }, [isHowToOpen]);

  useEffect (() => {
    console.log('Chaging Modal Selected Image to: ', selectedModalImg)
  }, [selectedModalImg]);

  // useEffect(() => {
  //   console.log('Setting Main index')
  // }, [mainIndex])


  const AboutModal = ({isOpen, onClose}) => {
    if (!isOpen) {
      return null;
    }

    return (
      <div className="about-overlay">
        <button className="close-btn-about" onClick={onClose}>X</button>
        <ul className="about-list">
          <li>Designer and Developer: <span className="text-orange">Abhisek Dey (DPRL, RIT)</span> <UserRoundCog size={24} /></li>
          <li>Patent Collection and Curation: <span className="text-orange">Nate Stanley (Insitro Inc.)</span> <User size={24} /></li>
          <li>PI and Supervisor: <span className="text-orange">Richard Zanibbi (DPRL, RIT)</span> <User size={24} /></li>
          <li>Submitted as a Demo Track Paper to <em>SIGIR 2025</em> <Newspaper size={24} /></li>
          <li>This work was supported by the National Science Foundation USA (Grant #2019897, Molecule Maker Lab Institute) <Atom size={24} /></li>
          <li>Developed as an alternative search for evolving chemical information needs <FlaskConical size={24} /></li>
        </ul>
      </div>
    )
  }

  const HowToModal = ({isOpen, onClose}) => {
    if (!isOpen) {
      return null;
    }

    return (
      <div className="about-overlay">
        <button className="close-btn-about" onClick={onClose}>X</button>
        <h3 className="about-list-header">Indexed Data <FileStack size={48} /></h3>
        <p className="about-list">UniChemFinder is a new attempt at Chemical Information Search where it
        indexes and links passages with molecule diagrams drawn anywhere in the PDF. The idea is to enable
        chemists to search relevant information about specific molecules or their synthesis pathways within
        specific genes at the passage level so chemists can quickly search PDFs for relevant synthesis data.
        We aim to demonstrate this using targteted search for gene inhibitor molecules/reactions and
        their synthesis pathways. <SiMoleculer size={24}/>
        </p>
        <p className="about-list">UniChemFinder currently indexes chemical information from <span className="text-orange">131</span> PDF patents 
        consisting of <span className="text-orange">32301</span> pages and <span className="text-orange">110k</span> passages. The patents have been
        manually collected and curated into their target genes from USPTO and WIPO. The PDFs are categorized into 12 genes
        and searches expose the gene information as well. E.g.: GLP-1, IRAK4. Refer to our paper for the full list of available genes.
        </p>
        <h3 className="about-list-header">Modes of Search <FileSearch2 size={48} /></h3>
        <ul className="about-list">
          <li><span className="text-orange">Text Only:</span> Queries containing text terms that may include common and IUPAC names for compounds and subgroups. 
          Query terms may include temperate, yield, reagent compounds, etc.</li>
          <li><span className="text-orange">SMILES Only:</span> Searching for single compounds or sub-groups as a SMILES string</li>
          <li><span className="text-orange">Multi-Modal:</span> Combine Text + SMILES search</li>
        </ul>

        <h3 className="about-list-header">Example Searches <FlaskConical size={48} /></h3>
        <p className="about-list">Some Example Searches To Try (Use either or both of <span className="text-yellow">Text</span> and  <span className="text-violet">SMILES</span> to 
        examine differences in search). Text should be provided in the <span className="text-yellow">Text Query</span> box 
        and SMILES should be in the <span className="text-violet">SMILES Query</span> box:</p>
        <ul className="about-list">
          <li><span className="text-yellow">difluoromethyl pyrimidine obtained with 400MHz NMR</span> + <span className="text-violet">[H]C(F)F</span></li>
          <li><span className="text-yellow">cyclopropyl pyrazol oxy flourobenzonitrile prepared with piperidin carboxylate</span> + <span className="text-violet">C1CCNCC1</span></li>
        </ul>
        <p className="about-list">After the passage results are displayed, click on any of the passage images to view the linked diagrams
        on the right panel</p>
      </div>
    )
  }

  const ExpandModalP = ({isOpen, onClose, index}) => {
    // If Modal Closed Do Not Render
    if (!isOpen)  {
    return null;
    }
    
    const PLImg = pLImgF[index];
    const DLImgs = dLImgsF[index];

    return (
      <div className="modal-overlay">
        <div className="modal-content">
          <div className="modal-header"> 
          {/* Header Section */}
          {
            <button key={0} className={`expand-btn2 ${selectedModalImg === 0 ? "active" : ""}`} onClick={() => setSelectedModalImg(0)} disabled={selectedModalImg === 0}>
              Passage
            </button>
          }

          {
            DLImgs.map((img, indexDL) => {
              return (
              <button key={indexDL+1} className={`expand-btn2 ${selectedModalImg === indexDL+1 ? "active" : ""}`} onClick={() => setSelectedModalImg(indexDL+1)} disabled={selectedModalImg === indexDL+1}>
              Diagram {indexDL+1}
              </button>
              )
            })
          }
            <button className="close-btn" onClick={onClose}>X</button>
          </div>
          
          {/* Display Selected Image Section */}
          <div className='modal-img-container'>
            {
              selectedModalImg === 0 && (
                <img key={0} src={PLImg} alt="Passage Image" className="modal-img"/>
              )
            }
            {
              DLImgs.map((DLImg, indexDLImg) => {
                return (
                  selectedModalImg === indexDLImg+1 && (
                    <img key={indexDLImg+1} src={DLImg} alt={`Diagram Image ${indexDLImg+1}`} className="modal-img"/>
                  )
                )
              })
            }
          </div>
        </div>
      </div>
    )

  };


  const handleClick = async () => {
    setLoading(true);
    setPData([]);
    setDLinks([]);
    setSelectedPassage(null);
    setExists(false);
    setIsModalOpenP(false);
    setSelectedModalImg(null);

    try {
      console.log('Sending Data: ', txtin, smiin);
      const response = await axios.post(
        'https://unichemfinder.gccis.rit.edu/process',
        {
          search1: txtin,  // Send directly in the body
          search2: smiin
        },
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );
      // Update the results
      if (Array.isArray(response.data.passage)) {
        setPData([...response.data.passage]);
        setDLinks([...response.data.dlinks]);
        setForceState((prev) => prev +1);
      }
      else {
        console.error("Backend did not return array");
      }

      // console.log('PDATA Response: '+ response.data.passage);
      // console.log('PDATA Passage: '+ pData);

    } catch (error) {
      console.error("Error fetching data: "+ error);
    }
    setLoading(false);
  }

  // Start search when user clicks "Enter" key as well
  const buttonRef = useRef(null);

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter") {
        buttonRef.current?.click(); // Simulate button click
      }
    };

    document.addEventListener("keydown", handleKeyPress);
    
    return () => {
      document.removeEventListener("keydown", handleKeyPress); // Cleanup event listener
    };
  }, []);

  useEffect(() => {
    console.log('Update pDATA after first UseEffect: '+pData);
  }, [pData, dLinks, forceState]);

  useEffect(() => {
    console.log('New pImg: '+JSON.stringify(pImgF));
    // console.log('New pLImg: '+pLImgF)
  }, [pImgF, pLImgF, dImgsF, dLImgsF]);

  // Force Update Search Variable States After Every 
  useEffect(() => {

    const imagePromises = [];

    // Loop through the metadata and create promises for each index
    for (const [indexP, pItems] of Object.entries(pData)) {
      // Push each call to the standalone function into the array
      imagePromises.push(
        FetchImages(indexP, pItems, dLinks)
          .then((response) => ({
            indexP,
            pimg: response.pimg,
            plimg: response.plimg,
            dimgs: response.dimgs,
            dlimgs: response.dlimgs,
            gene: response.gene,
          }))
          .catch((error) => ({
            indexP,
            pimg: null,
            plimg: null,
            dimgs: null,
            dlimgs: null,
            gene: null,
          }))
      );
    }

    // Wait for all promises to resolve using Promise.all
    Promise.all(imagePromises)
      .then((results) => {
        // Once all data is fetched, update the state
        const updatedpimg = {};
        const updatedplimg = {};
        const updateddimgs = {};
        const updateddlimgs = {};
        const updatedgene = {};

        // Process the results of each promise
        results.forEach((result) => {
          updatedpimg[result.indexP] = result.pimg;
          updatedplimg[result.indexP] = result.plimg;
          updateddimgs[result.indexP] = result.dimgs;
          updateddlimgs[result.indexP] = result.dlimgs;
          updatedgene[result.indexP] = result.gene;
        });

        // Update state with the fetched data
        setPImgF(updatedpimg);
        setPLImgF(updatedplimg);
        setDImgsF(updateddimgs);
        setDLmgsF(updateddlimgs);
        setGeneF(updatedgene);
      })
      .catch((error) => {
        console.error('Error fetching all data:', error);
      });
      // if (pData.length > 0) {
      //   console.log('PDATA UPDATED...Fetching Images' + pData);
        
      //   // pData.forEach((pItems, indexP) => {
      //   for (const [indexP, pItems] of Object.entries(pData)) {
      //     const { pImg, pLImg, dImgs, dLImgs, gene } = FetchImages(indexP, pItems, dLinks);
      //     console.log(`New Image from Fetch: ${pImg} index ${indexP} for item ${JSON.stringify(pItems)}`)
          
      //     if (pImg) {
      //     // Set the state of all fetched data (Append)
      //     setPImgF((prevData) => ({...prevData, [indexP]: pImg}));
      //     setPLImgF((prevData) => ({...prevData, [indexP]: pLImg}));
      //     setDImgsF((prevData) => ({...prevData, [indexP]: dImgs}));
      //     setDLmgsF((prevData) => ({...prevData, [indexP]: dLImgs}));
      //     setGeneF((prevData) => ({...prevData, [indexP]: gene}));
      //     // console.log('PImg for Index:'+indexP+' is '+pImgF);
      //   }};
      // }

  }, [pData]);

  const FetchImages = async (indexP, item, dLinks) => {
    try {
      const response = await axios.post(
        'https://unichemfinder.gccis.rit.edu/render',
        {
          plist: item,  // Send the dictionaries directly
          dlists: dLinks
        },
        {
          headers: {
            "Content-Type": "application/json"
          },
          timeout: 30000
        }
      );
      // Return the responses

      // console.log('PImg for index ' + indexP + ' is '+ response.data.pimg);
      return {'pimg': response.data.pimg, 'plimg': response.data.plimg, 
        'dimgs': response.data.dimgs, 'dlimgs': response.data.dlimgs, 'gene': response.data.gene};
  
    } catch (error) {
      console.error("Error Passage data: " + error + 
        "  For passage item: " + item + "Index Key " + indexP);
    }
  
    return null;  
  }

  const handleDExpandClick = (counterVal) => {
    console.log('Setting DImg Modal Img Selected as: ', counterVal+1);
    setSelectedModalImg(counterVal+1);
  }

  const PassageDefaultMessage = () => {
    if (pData.length > 0) {
      return null;
    }

    return (
      <p className="img-block">Enter a valid search above to get started <FaHourglassStart size={24} /></p>
    )
  }
  

  return (
    <div class='base-page'>
      {/* Search Bar */}
      <div class='full-logo-bar'>
        <div className="full-logo-bar-left">
          <img src={full_logo} alt='Full Logo' class='full-logo-img'/>
        </div>
        <div className="full-logo-bar-right">
        <button onClick={() => setIsHowToOpen(true)} class='search-btn-howto'>
          <SearchCode size={18} />
          <span className="how-to-spacing">How To</span>
          </button>
          <button className="about-btn" onClick={() => setIsAboutOpen(true)}>
            <Info size={18} />
            <span className="about-spacing">About</span>
          </button>
          <img src={dprl_logo} alt='dprl_logo' className='ack-logos-dprl' />
          <img src={rit_logo} alt='rit_logo' className='ack-logos-rit' />
          <img src={nsf_logo} alt='nsf_logo' className='ack-logos-nsf' />
        </div>
      </div>
      <div class='logo-search-bar'>
        <img src={logo1} alt='Small Logo' class='small-logo-img' />
        <input type='text' value={txtin} onChange={handleTxtIn} placeholder="Text Query" class='search-box' />
        <input type='text' value={smiin} onChange={handleSMIIn} placeholder="SMILES Query" class='search-box' />
        <button onClick={handleClick} class='search-btn' disabled={loading} ref={buttonRef}>{loading ? "Running.." : "Search"}</button>
        {
          loading && <div className="spinner" />
        }
      </div>
      {/* Main Body */}
      <AboutModal isOpen={isAboutOpen} onClose={() => setIsAboutOpen(false)} />
      <HowToModal isOpen={isHowToOpen} onClose={() => setIsHowToOpen(false)} />
      <ExpandModalP isOpen={isModalOpenP} onClose={() => setIsModalOpenP(false)} index={selectedPassage} />
      <div class='main-container'>
        <div class='p-container'>
          <div class='container-header'>Passage Results</div>
          {
            <PassageDefaultMessage />
          }
          
          { 
            pData.map((item, indexP) => {
              const pImg = pImgF[indexP];
              const gene = geneF[indexP];
              const curDocno = item.docno;
              // Count the number of diagram matches
              const DCount = dLinks.filter(itemD => itemD.docno === curDocno).length;
              
              return (
              geneF ? (
              <div class='img-block'>
                <div class={`${selectedPassage !== indexP ? 'img-header-p' : 'img-header-p-selected'}`}>
                  <p class='img-header-txt'><span className="text-orange">({DCount})</span> Rank: {indexP+1}, Gene: {gene}, PDF: {item.Doc}, Page: {item.Page}</p>
                  <button onClick={() => {setIsModalOpenP(true); setSelectedPassage(indexP); setSelectedModalImg(0);}} class='expand-btn'>Expand View</button>
                </div>
                
                <img key={indexP} src={pImg} 
                alt={`Generated Rank ${indexP} image`} class={`${selectedPassage === indexP ? 'highlight-img': 'container-img'}` } 
                onClick={() => handlePassageClick(indexP)} />
              </div> ) : (<p className="img-block">Waiting to Render Rank {indexP+1}...</p>)
                );   
              })
              
          }
        </div>
        <div class='d-container'>
          <div class='container-header'>Diagram Results</div>
          {
            exists ? (
              dLinks.map((dImgMeta) => {
                const pDocno = pData[selectedPassage].docno;
                const dDocno = dImgMeta.docno;
                if (pDocno === dDocno) {
                  const gene = geneF[selectedPassage];
                  tempCounter++;
                  const curDImg = dImgsF[selectedPassage][tempCounter];
                  const curDImgIdx = tempCounter;
                  return (
                    <div class='img-block'>
                      <div class='img-header-p'>
                        <p class='img-header-txt'>Page: {dImgMeta.Page} </p>
                        <p class='img-header-txt'>IUPAC: {dImgMeta.Name}</p>
                        <p class='img-header-txt'>SMILES: {dImgMeta.SMI}</p>
                        <button onClick={() => {handleDExpandClick(curDImgIdx); setIsModalOpenP(true);}} class='expand-btn'>Expand View</button>
                      </div>
                      <img key={tempCounter} src={curDImg} alt={`Rank ${tempCounter} Diagram Match`} class='container-img' />
                    </div>
                  )
                }
              })
            ) : (
            <div className='img-block'>
            <p className="text-align-pdefault">No Diagram Matches exists for Selected Passage</p>
            <p className="text-align-pdefault">Click on a passage On the left to see linked diagrams<br />
            The number within brackets <span className="text-orange">(x)</span> shows
            available number of compound diagrams for each passage.
            </p>
            </div>
          )
          }
        </div>

      </div>
    </div>
  )

}

export default App;
